import { useQuery, useMutation } from 'convex/react';
import { api } from '../../../../convex/_generated/api';
import { useEffect } from 'react';

/**
 * Hook to get and manage the current user's profile
 * Automatically creates profile on first use
 */
export function useProfile() {
  const profile = useQuery(api.profiles.getCurrentProfile);
  const ensureProfile = useMutation(api.profiles.ensureProfile);
  const updateProfile = useMutation(api.profiles.updateProfile);

  // Ensure profile exists when user is authenticated
  useEffect(() => {
    if (profile === null) {
      // Profile doesn't exist, create it
      ensureProfile();
    }
  }, [profile, ensureProfile]);

  return {
    profile,
    isLoading: profile === undefined,
    updateProfile,
  };
}
